module.exports = __webpack_public_path__ + "static/media/request-received-search.64d36595.svg";